<template>
  <div class="container container-table text-center">
    <div v-if=response class="text-red"><p>{{response}}</p></div>

    <div class="middle">
      <a id="signin-button" v-on:click="signIn">
        Sign in with Google
      </a>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'Login',
    data: function (router) {
      return {
        section: 'Login',
        response: ''
      }
    },
    methods: {
      signIn: function () {
        this.$auth.signIn((error) => {
          if (error) {
            this.response = error.toString()
          } else {
            this.$router.push({
              name: 'Home'
            })
          }
        })
      }
    }
  }
</script>

<style>
  #signin-button {
    display: inline-block;
    height: 46px;
    width: 191px;
    background: url('../assets/google_signin_buttons/web/2x/btn_google_signin_light_normal_web@2x.png');
    background-size: 191px 46px;
    text-indent: -999em;
  }

  .container-fluid {
    height: calc(100% - 96px);
  }

  .container-table {
    display: table;
    height: 100%;
  }

  .middle {
    display: table-cell;
    vertical-align: middle;
  }
</style>


// WEBPACK FOOTER //
// Login.vue?cc9af1d4